import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({color = '#5C6570', width = '100%', height = '100%'}) => (
  <svg width={width} height={height} viewBox="0 0 101 132" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="desktop-work-in-progress-"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="BYO---error-state-Copy"
        transform="translate(-193.000000, -373.000000)"
        stroke={color}
        strokeWidth="3.24675325"
      >
        <g id="Page-1" transform="translate(195.000000, 375.000000)">
          <path d="M0,115.387526 L0,81.7174924" id="Stroke-1" />
          <path d="M74.992304,115.387686 L74.992304,63.351451" id="Stroke-3" />
          <path d="M67.3400673,89.3698894 L67.3400673,63.3525734" id="Stroke-4" />
          <g id="Group-16" transform="translate(7.413340, 0.364438)">
            <path
              d="M81.3530544,46.1526375 L0.238736572,46.1526375 L0.238736572,127.266955 L26.2945326,127.266955 C26.6953664,119.594998 33.0237294,113.492705 40.7966971,113.492705 C48.5680616,113.492705 54.8964246,119.594998 55.2972583,127.266955 L81.3530544,127.266955 L81.3530544,46.1526375 Z"
              id="Stroke-5"
              strokeLinejoin="round"
            />
            <path
              d="M81.3530544,0.238896906 L55.2972583,0.238896906 C54.8964246,7.91085458 48.5680616,14.0131473 40.7966971,14.0131473 C33.0237294,14.0131473 26.6953664,7.91085458 26.2945326,0.238896906 L0.238736572,0.238896906 L0.238736572,46.1519962 L81.3530544,46.1519962 L81.3530544,0.238896906 Z"
              id="Stroke-7"
              strokeLinejoin="round"
            />
            <g id="Group-11" transform="translate(88.786756, 10.223345)" strokeLinejoin="round">
              <path d="M0.218694885,31.5507456 L0.218694885,0.000320666987" id="Stroke-9" />
            </g>
            <path d="M11.8266795,45.4967132 L11.8266795,32.6700337" id="Stroke-12" />
            <path d="M11.8266795,27.8600289 L11.8266795,21.4466891" id="Stroke-14" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SVG.propTypes = {
  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Width in pixels
   */
  width: PropTypes.string,

  /**
   * Height in pixels
   */
  height: PropTypes.string,
};
export default SVG;
